"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { CircleCheck, Target, TrendingUp } from "lucide-react";
export default function OperationalApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: CircleCheck,
    title: "Operational Discipline",
    description: "Designed to support consistent performance through efficient processes, clear standards, and operational rigor."
  }, {
    icon: Target,
    title: "Long-Term Sustainability",
    description: "Intended to operate with predictable performance, thoughtful capital allocation, and a focus on enduring value."
  }, {
    icon: TrendingUp,
    title: "Efficiency & Safety",
    description: "Modern systems, high-capacity equipment, and well-lit environments designed for safe, efficient customer flow."
  }];
  return <section id="operational-approach" ref={ref} className="bg-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Operational Approach
          </h2>
          <p className="mt-4 text-muted-foreground">A disciplined framework designed to support predictable performance and long-term sustainability.<br /><br />Prime Laundry is being developed with lender-aligned underwriting, disciplined capital deployment,<br />and long-term operational stability in mind.</p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          const delay = i * 150;
          return <Card key={i} data-index={i} className={`group border border-border bg-white shadow-soft transition-all duration-[80ms] ease-in-out hover:border-border-strong hover:shadow-medium ${isVisible ? "animate-reveal" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                <CardHeader className="items-center text-center">
                  <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-md bg-primary-light transition-transform duration-[80ms] ease-in-out group-hover:-translate-y-1">
                    <Icon className="h-8 w-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}